export const CARD_TYPE_DEF_GET = "/CardType/GetAllCardType"